import { TaskTypeDescriptor } from '../../../../taskTypes/descriptor';

/**
 * Case-insensitive substring match on `displayName`. Kept pure + separate so
 * the filter logic stays unit-testable and matches the Users/Campaigns tools'
 * conventions. Only `displayName` is considered — the id and description are
 * advisory context in the row, not the primary lookup key admins think in.
 */
export function filterTaskTypes(
  modules: TaskTypeDescriptor[],
  query: string,
): TaskTypeDescriptor[] {
  const q = query.trim().toLowerCase();
  if (!q) return modules;
  return modules.filter((m) => (m.displayName ?? '').toLowerCase().includes(q));
}

/** Alphabetical by display name (falls back to id). Returns a new array. */
export function sortTaskTypes(modules: TaskTypeDescriptor[]): TaskTypeDescriptor[] {
  const label = (m: TaskTypeDescriptor) => m.displayName || m.id;
  return [...modules].sort((a, b) => label(a).localeCompare(label(b), undefined, { sensitivity: 'base' }));
}
